module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-template-svg",
    attrs: {
      "id": "content-template-plano-svg"
    }
  }, [(_vm.favorite !== null) ? _c('AddFavorite') : _vm._e(), _vm._v(" "), _c('MenuLayer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActiveLayer),
      expression: "isActiveLayer"
    }],
    attrs: {
      "items": _vm.itemsLayer,
      "x": _vm.layerX,
      "y": _vm.layerY
    }
  }), _vm._v(" "), (_vm.loader) ? _c('LoaderInfo') : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "cluster-builder",
    attrs: {
      "id": "cluster",
      "width": "100%",
      "height": "100%"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42dd617b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/common/TemplatePlano.vue
// module id = 3148
// module chunks = 0